import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "loading"]
  static values = {endpoint: String}

  connect() {
    this.interval = setInterval(() => {
      this.checkStatus()
    }, 3000)
  }

  async checkStatus() {
    const session = await fetch(this.endpointValue)
    const session_status = await session.json()

    if (session_status.status == 'complete') {
      this.buttonTarget.classList.remove("hidden")
      this.loadingTarget.classList.add("hidden")
      clearInterval(this.interval)
    }
  }
}